import React from "react";
import { MoreVert } from "@mui/icons-material";
import {
  Grow,
  Paper,
  Popper,
  MenuItem,
  MenuList,
  IconButton,
  ClickAwayListener,
} from "@mui/material";

type Option = { label: string; onClick: () => void };

export const MoreButton = ({ options }: { options: Option[] }) => {
  const anchorRef = React.useRef<HTMLDivElement>(null);

  const [visible, setVisible] = React.useState(false);

  const handleClose = (event: Event) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }

    setVisible(false);
  };

  return (
    <div style={{ position: "relative" }} ref={anchorRef}>
      <IconButton
        onClick={(event) => {
          event.stopPropagation();
          event.preventDefault();

          setVisible((prev) => !prev);
        }}
      >
        <MoreVert />
      </IconButton>

      <Popper
        transition
        disablePortal
        open={visible}
        role={undefined}
        sx={{ zIndex: 1 }}
        anchorEl={anchorRef.current}
      >
        {({ TransitionProps, placement }) => {
          return (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === "bottom" ? "center top" : "center bottom",
              }}
            >
              <Paper variant="elevation" elevation={6}>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList id="split-button-menu" autoFocusItem={false}>
                    {options.map((option, index) => (
                      <MenuItem
                        key={`split-button-menu-item-${index}`}
                        onClick={(event) => {
                          event.preventDefault();
                          event.stopPropagation();

                          option.onClick();
                          setVisible(false);
                        }}
                      >
                        {option.label}
                      </MenuItem>
                    ))}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          );
        }}
      </Popper>
    </div>
  );
};
